import { Avatar, CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  avatar: {
    width: '50px',
    height: '50px',
    borderRadius: '25%',
  },
}));

const TicketInfo = ({ contact, ticket, onClick, typingIndicator }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const queueLabel = ticket.queue ? ticket.queue.name : 'Nenhum';
  const attendantLabel = ticket.user
    ? `${t('messagesList.header.assignedTo')} ${ticket.user.name}`
    : `${t('messagesList.header.assignedTo')} -`;

  const statusLabel = `${attendantLabel} | Setor: ${queueLabel}`;

  return (
    <CardHeader
      onClick={onClick}
      style={{ cursor: 'pointer' }}
      titleTypographyProps={{ noWrap: true }}
      subheaderTypographyProps={{ noWrap: true }}
      avatar={
        <Avatar
          src={contact.profilePicUrl}
          className={classes.avatar}
          alt="contact_image"
        />
      }
      title={`${contact.name} #${ticket.id}`}
      subheader={typingIndicator || statusLabel}
    />
  );
};

export default TicketInfo;
